// extracted by mini-css-extract-plugin
export default {"wrapper":"MiniSchedule_wrapper__G7ULz","header":"MiniSchedule_header__QyyhS","body":"MiniSchedule_body__IsiBO","refresh_button":"MiniSchedule_refresh_button__KK5Jf"};